export default "__VITE_ASSET__vZAukE3C__"